import { breakpoints, ColorKeys, colors, createMarkup, DynamicLink, Flex, Icon, IconTypes, Rte, Text } from '@capioweb/ui-components/src'
import { XhtmlString } from '../../@types/CapioWeb/core'
import { LinkItemProperty, StringProperty } from '../../@types/EpiFoundationSpa/Property'
import { BlockCommonLayout } from '../../utils/layout'
import { ChildrenProps } from '@capioweb/ui-components/src/@types/@core'
import styled from 'styled-components'
import { sendPatientInfoCardDataLayerPush } from '../../utils'
import { Button } from '@capioweb/ui-components'

interface PatientInfoContainerBlockProps {
    heading2: StringProperty
    heading3: StringProperty
    layout: "threeColumnLayout" | "twoColumnLayout"
    content: { value: PatientInfoCardType[] }
}

type PatientInfoCardType = {
    icon: StringProperty
    heading: StringProperty
    text: StringProperty
    backgroundColor: StringProperty
    link: LinkItemProperty
    cta: LinkItemProperty
}

interface PatientInfoCardProps {
    icon: IconTypes
    heading: string
    text: XhtmlString
    backgroundColor: ColorKeys
    link: LinkItemProperty
    cta: LinkItemProperty
    layout: "threeColumnLayout" | "twoColumnLayout"
}

interface CardWrapperProps extends ChildrenProps {
    url: string
    target?: string
    title?: string
    name?: string
    heading: string
    sendPush: boolean
}

const CardWrapper: React.FC<CardWrapperProps> = (props) => {

    if (props.url) {
        return <DynamicLink onClick={() => props.sendPush && sendPatientInfoCardDataLayerPush(props.heading, "Link", "")} display='flex' url={props.url}>{props.children}</DynamicLink>
    }
    else {
        return <>{props.children}</>
    }

}

const PatientInfoCard: React.FC<PatientInfoCardProps> = (props) => {

    const layoutTwoColumn = 'calc(50% - 12px)'
    const layoutThreeColumn = 'calc(100% / 3 - 16px)'

    const CardStyled = styled.div`
    display: flex;
    flex-grow: 1;
    border: 1px solid transparent;
    border-radius: 24px;    
    
    :hover {   
        border-color: ${props.link?.value?.href && colors.hoverBlue};
        
        & path {
            fill: ${colors.hoverBlue};
        }
    }

    @media screen and (min-width: ${breakpoints.m}px) {
        max-width: ${props.layout === 'threeColumnLayout' ? layoutThreeColumn : layoutTwoColumn};
    }
    `
    return (
        <CardStyled>

            <CardWrapper url={props.link?.value?.href ?? ''} heading={props.heading} sendPush={!props.cta?.value?.href}>
                <Flex h='auto' backgroundColor={props.backgroundColor} w={1} p={3} borderRadius='24px'>
                    <Flex flexDirection='column' justifyContent='space-between' w={1} rowGap={1}>
                        <Flex flexDirection='column' w={1} rowGap={1}>
                            <Flex columnGap={1} alignItems='center'>
                                {props.icon &&
                                    <Flex>
                                        <Icon icon={props.icon}></Icon>
                                    </Flex>
                                }
                                <Text variant='headline-3' mb={0}>{props.heading}</Text>
                            </Flex>
                            <Rte>
                                <div dangerouslySetInnerHTML={createMarkup(props.text.value)}></div>
                            </Rte>
                            {props.cta && props.cta.value && (
                                <Flex>
                                    <Button.Link
                                        to={props.cta?.value.href}
                                        title={props.cta?.value.title}
                                        onClick={() => sendPatientInfoCardDataLayerPush(props.heading, "CTA", props?.cta?.value.text)}
                                    >
                                        {props.cta?.value.text}
                                    </Button.Link>
                                </Flex>
                            )}
                        </Flex>
                        {props.link?.value?.href &&
                            <Flex w={1} justifyContent='flex-end'>
                                <Icon icon='arrow-right'></Icon>
                            </Flex>
                        }
                    </Flex>
                </Flex>
            </CardWrapper>
        </CardStyled>

    )
}


const PatientInfoContainerBlock: React.FC<PatientInfoContainerBlockProps> = ({ heading2, heading3, content, layout }) => {

    return (
        <BlockCommonLayout>
            <Flex w={1} flexDirection='column'>
                {heading2?.value &&
                    <Text variant="headline-2" textAlign='center' mb={2} >{heading2.value}</Text>
                }
                {heading3?.value &&
                    <Text variant="headline-3" mb={1} >{heading3.value}</Text>
                }
                <Flex flexWrap='wrap' columnGap={3} rowGap={{ _: 2, m: 3 }}>
                    {content.value.map((card, index) => (
                        <PatientInfoCard
                            key={index}
                            icon={card.icon.value as IconTypes}
                            heading={card.heading.value}
                            text={card.text}
                            backgroundColor={card.backgroundColor.value as ColorKeys}
                            link={card.link}
                            cta={card.cta}
                            layout={layout}
                        />
                    ))}
                </Flex>
            </Flex>

        </BlockCommonLayout>
    )
}

export { PatientInfoContainerBlock }
